"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMeetingCounters = void 0;
/**
 * @deprecated
 * @see MeetingHas
 */
var EMeetingCounters;
(function (EMeetingCounters) {
  EMeetingCounters["participantsLeft"] = "participantsLeft";
  EMeetingCounters["meetingGroup"] = "meetingGroup";
  EMeetingCounters["reservationExpireDate"] = "reservationExpireDate";
  EMeetingCounters["extensionCostPerHour"] = "extensionCostPerHour";
})(EMeetingCounters = exports.EMeetingCounters || (exports.EMeetingCounters = {}));
